var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"CheckInput"},[_c('input',_vm._b({staticClass:"CheckInput__native",attrs:{"tabindex":"-1"}},'input',{ type: _vm.type, checked: _vm.checked },false)),_vm._v(" "),_c('span',{staticClass:"CheckInput__custom"})])}
var staticRenderFns = []

export { render, staticRenderFns }